import WebpackConstants from "../constant/WebpackConstants";
import _ from "lodash";
import queryString from "query-string";

const isProduction = process.env.NODE_ENV === WebpackConstants.NODE_ENV.PRODUCTION;
const flags = process.env.FLAGS;
const isUpload = _.includes(flags, WebpackConstants.FLAG.UPLOAD);
let isInited = false;

const loadUploadScript = (bid) => {
    !(function(c,i,e,b){var h=i.createElement("script");
        var f=i.getElementsByTagName("script")[0];
        h.type="text/javascript";
        h.crossorigin=true;
        h.onload=function(){c[b]||(c[b]=new c.wpkReporter({
            bid,
            rel: WebpackConstants.NURSECARE_COMPILE_INFO.VERSION,
        }));
            c[b].installAll()};
        f.parentNode.insertBefore(h,f);
        h.src=e})(window,document,"https://g.alicdn.com/woodpeckerx/jssdk??wpkReporter.js","__wpk");
}

const init = () => {
    const queryArg = queryString.parse(window.location.search);
    const bid = queryArg.bid;
    if (!isInited && isUpload && isProduction && bid) {
        loadUploadScript(bid);
        isInited = true;
    }
}

export default {
    init,
}
